import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {

    constructor(private http: HttpClient) {
    }

    apiBaseUrl(): string {
        return (window as any)['env']?.API_BASE_URL || 'http://localhost:8080';
    }

    salesApiBaseUrl(): string {
        return this.apiBaseUrl();
    }

    getTitle() {
        return (window as any)['env']?.TITLE || "Wacni";
    }
}
